<template>
  <div class="clientprofile">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col-sm-12">
                <h3 class="page-title">Roles</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">
                    <router-link to="/agent/list">Agent</router-link>
                  </li>
                  <li class="breadcrumb-item active">Roles</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- /Page Header -->

          <div class="card mb-0">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="profile-view" v-if="!!loading">
                    <div class="row">
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                        <ul class="personal-info">
                          <li>
                            <span class="title">Phone:</span>
                            <span class="text">
                              <Skeleton :count="1" />
                            </span>
                          </li>
                          <li>
                            <span class="title">Email:</span>
                            <span class="text">
                              <Skeleton :count="1" />
                            </span>
                          </li>
                        </ul>
                      </div>
                      <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8">
                        <h6 class="card-title m-b-20">Roles Access</h6>
                        <div class="m-b-30">
                          <ul class="list-group notification-list">
                            <li class="list-group-item">
                              <Skeleton :count="1" />
                              <div class="status-toggle">
                                <Skeleton :count="1" />
                              </div>
                            </li>
                            <li class="list-group-item">
                              <Skeleton :count="1" />
                              <div class="status-toggle">
                                <Skeleton :count="1" />
                              </div>
                            </li>
                            <li class="list-group-item">
                              <Skeleton :count="1" />
                              <div class="status-toggle">
                                <Skeleton :count="1" />
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                      <ul class="personal-info">
                        <li>
                          <span class="title">Name:</span>
                          <span class="text">{{agentInfo.first_name}} {{agentInfo.last_name}}</span>
                        </li>
                        <li>
                          <span class="title">Email:</span>
                          <span class="text">{{agentInfo.email}}</span>
                        </li>
                      </ul>
                    </div>
                    <div class="col-sm-8 col-md-8 col-lg-8 col-xl-8">
                      <h6 class="card-title m-b-20">Roles Access</h6>
                      <div class="m-b-30">
                        <ul
                          class="list-group notification-list"
                          v-for="(row,index) in listData"
                          :key="index"
                        >
                          <li class="list-group-item">
                            {{row.license_name}}
                            <small
                              class="text-muted"
                            >{{row.license_phone_number}}</small>
                            <router-link
                              :to="'/omni/connect-to-agent-owner?license_id='+row.id+'&agent_id='+id"
                              class="text-success"
                              v-if="formInput[index]==true"
                            >
                              <i class="fa fa-chevron-circle-right"></i>
                            </router-link>
                            <div class="status-toggle">
                              <!-- {{formInput[index]}} -->
                              <input
                                type="checkbox"
                                :ref="'ref_'+row.id"
                                :id="'license_'+row.id"
                                class="check"
                                v-model="formInput[index]"
                                @change="updateOrDelete(row.id,index)"
                              />
                              <label :for="'license_'+row.id" class="checktoggle">checkbox</label>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import Whatsapp from "./whatsapp.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    Whatsapp
  },
  computed: {
    ...mapGetters(["fieldsGetLicenseList"])
  },
  async created() {
    // console.log("route", this.$route.query.id);
    this.id = await this.$route.query.id;
    await this.getAgentById(this.id);
    await this.getLicenseList(this.id);
  },
  data() {
    return {
      id: "",
      formInput: [],
      listData: [],
      loading: false,
      agentInfo: {
        id: "",
        network_id: 0,
        email: "",
        first_name: "",
        last_name: "",
        create_datetime: 0,
        update_datetime: 0,
        is_owner: 0,
        timezone: "UTC"
      }
    };
    //  isactive : true
  },
  methods: {
    async updateOrDelete(licenseId, index) {
      var params = await {};
      params = await {
        agent_id: this.id,
        license_id: licenseId
      };
      this.loading = await true;
      // console.log("check", this.formInput[index]);
      // await console.log("check", licenseId, this.formInput[index]);
      if (this.formInput[index] == true) {
        this.$store.dispatch("agent/updateAgentRolesOneStored", params);
      } else {
        this.$store
          .dispatch("agent/deleteAgentRolesOneStored", params)
          .catch(() => {
            var that = this;
            setTimeout(function() {
              that.formInput[index] = true
              // console.log("index", index);
            }, 200);
          });
      }
      this.loading = await false;
    },
    async getLicenseList(agentId) {
      this.loading = await true;

      await this.$store
        .dispatch("license/getLicenseList", this.fieldsGetLicenseList)
        .then(async response => {
          var { data } = await response;
          this.listData = await data.data;
          for (var i = 0; i < this.listData.length; i++) {
            await this.getAgentRel(agentId, this.listData[i].id, i);
          }
        });
      this.loading = await false;
    },
    async getAgentRel(agentId, licenseId, index) {
      var params = await {};
      params = await {
        agent_id: agentId,
        license_id: licenseId
      };
      this.loading = await true;
      await this.$store
        .dispatch("agent/getAgentRel", params)
        .then(async response => {
          var { data } = await response;
          // console.log("index", index, data);
          this.formInput[index] = await data;
        });

      this.loading = await false;
    },
    async getAgentById(id) {
      this.loading = await true;

      await this.$store
        .dispatch("agent/getAgentById", id)
        .then(response => {
          var { data } = response;
          this.agentInfo = data;
        })
        .catch(error => {
          // this.$route.push({to:"/license/list"})
          this.$router.replace({ path: "/agent/list" });
        });
      this.loading = await false;
    }
  },
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "clientprofile"
};
</script>


// WEBPACK FOOTER //
// src/views/agent/roles.vue